<template>
  <div class="sup">
    <p class="supHeader">
        <span :class="selected=='gong'?'herderactive':''" @click="supplyCut('gong')">供应类</span>
        <span :class="selected=='xu'?'herderactive':''" @click="supplyCut('xu')">采购类</span>
      </p>
    <div class="bar">
      <ul class="barList">
        <li :class="active==item.sortid?'barItem active':'barItem'" v-for="(item,i) in barList" :key="'bar'+i" @click="supFilter(item.sortid)">{{item.name}}</li>
      </ul>
    </div>
        <Comments :list="list" :listnum="listnum*1" @loading="loading"/>
    <div class="add">
      <i class="iconfont icon-jia"></i>
    </div>
    
  </div>
</template>

<script>
import Comments from "./comments";
import { reqSupply } from '../../../api/index'
export default {
  props: ['barList'],
  components:{
    Comments
  },
  data () {
    return {
      selected:"gong",//类别
      active:"0",//小类（石油石化）
      list:[],//数据列表
      page:1,//当前页
      pagenum:10,//每页条数
      listnum:Number,//总条目数
    }
  },
  mounted () {
    this.supplyCut("gong")
  },
  methods:{
    loadMore(){
    },
    // 请求
    async supplyCut(selected,page,sortid,falg=true){
      this.selected=selected
      const response = await reqSupply(selected,page,sortid)
      if(response.code==0){
        
        this.page = response.thispage
        this.pagenum = response.pagelistnum
        this.listnum = response.listnum*1
        if (falg) {
          this.list=response.resilt
        }else{
          this.list.push(...response.resilt)
        }
      }else{
        this.list=[]
      }
    },
    // 筛选
    supFilter(sortid){
      this.active = sortid
      if (sortid!=0) {
        this.supplyCut(this.selected,1,sortid)
      }else{
        this.supplyCut(this.selected,1)
      }
    },
    // 加载更多
    async loading(){
      this.supplyCut(this.selected,this.page*1+1,this.active,false)
    }
    
  }
}
</script>

<style scoped>
  .mint-navbar .mint-tab-item{
    width: 50%;
  }
  .sup{
    background-color: #eee;
    margin-left: -10px;
    margin-right: -10px;
    min-height: 100%;
  }
  .supHeader{
    /* height: 60px; */
    background-color: white;
    vertical-align: bottom;
    line-height: 60px;
    font-size: 18px;
    text-align: center;
  }
  .supHeader span:first-child{
    margin-right: 20px;
  }
  .bar{
    position: relative;
    width: 100%;
    height: 45px;
    background-color: white;
    padding-right: 20px;
    margin: 20px 0;
    /* padding: 10px 30px 10px 10px; */
    padding: 10px 10px 10px 10px;
  }
  .barList{
    height: 100%;
    /* width: 100%; */
    white-space: nowrap;
    overflow-x: auto;  
    margin-bottom: -7.5px;  
  }
  .barItem{
    padding: 0 10px;
    line-height: 25px;
    margin-right: 3px;
    background-color: #efefef;
    display: inline-block;
    font-size: 15px;
    border-radius: 4px;
  }
  
  .bar i{
    position: absolute;
    right: 10px;
    top: 13px;
    font-size: 18px;
  }
  .add{
    position: absolute;
    bottom: 80px;
    right: 30px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #008baf;
    color: white;
    text-align: center;
    line-height: 40px;
  }
  .add i{
    font-size: 30px;
  }
  .herderactive{
    color: #008baf;
    border-bottom: #008baf solid 1px;
  }
  .active{
    background-color: #f08300;
  }
  
</style>